import React from 'react';
import SvgIcon from './SvgIcon';

const CaretRight = props => (
    <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M.872 18.372L11.998 5.797a.5.5 0 01.748 0l11.126 12.575"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

CaretRight.displayName = 'CaretRightIcon';

export default CaretRight;
